import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './components/Home';
import ReviewsPage from './components/Review';
import Landing from './components/Landing';
import AdminPanel from './components/AdminPanel';
import { trackPageView } from './analytics';

/* Tracks GA4 page view on every route change */
function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

const App = () => {
  return (
    <Router>
      <PageViewTracker />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/home" element={<Home />} />
        <Route path="/college/:collegeId/reviews" element={<ReviewsPage />} />
        <Route path="/admin-updates" element={<AdminPanel />} />
      </Routes>
    </Router>
  );
};

export default App;

